import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { loadW9File } from 'router/loaders/shared';
import { hasUserSubmittedPricingStep } from 'router/loaders/utils/validation';
import { isVerified } from 'services/partnersSelfSignup/otp';
import { signupSearchParams } from 'router/search/signup';
import { beforeLoadSignupSubRoute, headSignupSubRoute } from 'router/utils';
import { validateTaxDetailsLeadStatus } from 'router/validateLeadStatus';
import { GROWTHBOOK_ENUM_DEFAULTS } from 'utils/experimentation';

export const Route = createFileRoute('/_signup/gym/tax-details')({
  validateSearch: zodValidator(signupSearchParams),
  head: headSignupSubRoute,
  beforeLoad: ({ context, location, preload, cause }) => {
    if (!preload) {
      // TODO
      /* this will only evaluate the flag so salesforce can use it before creating an opp for a lead that won't be going through RTO flow.
       this shall be removed after experiment is done */
      context.growthbook.getFeatureValue(
        'partners.acquisition.commercial-conditions',
        GROWTHBOOK_ENUM_DEFAULTS['partners.acquisition.commercial-conditions'],
      );
    }

    return beforeLoadSignupSubRoute({
      context,
      location,
      preload,
      cause,
      validateLeadStatus: validateTaxDetailsLeadStatus,
      validation: {
        validate: async ({ lead }) => {
          if (
            !hasUserSubmittedPricingStep(lead) ||
            !(await isVerified({
              queryClient: context.queryClient,
              email: lead.businessEmail ?? '',
            }))
          ) {
            throw redirect({ to: '/pricing' });
          }

          return true;
        },
      },
    });
  },
  loader: ({ context }) => loadW9File(context),
});
